// actions/parameter.actions.ts
import { createAction, props } from '@ngrx/store';
import { DeviceProperty } from '../models/parameter.state';

export const setParameterValue = createAction(
  '[Parameter] Set Parameter Value',
  props<{ parameterValue: DeviceProperty }>()
);
